import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
	state: () => ({
		open: false,
		title: '',
		paragraphs: '',
		interactive_html: '',
		buttons: [],
		options: {},
		on_dismiss_callback: null,

		is_license_key_modal_open: false,
		is_extend_license_key: false,
		is_audio_studio_modal_open: false,

		is_BETA_welcome_modal_open: false,
		view_dmx_effect: null,

		open_new_label_template_modal: false,
		open_edit_label_modal: false,
		open_template_settings_modal: false,

		is_export_errors_modal_open: false,
		is_auto_address_modal_open: false,
		auto_address_apply_to_target: 'entire_show',
		auto_address_target_position_label: null,
		auto_address_opened_from_export: false,
	}),
	actions: {
		createInteractiveModal({ title = '', paragraphs = [], interactive_html = '', buttons = [], options = {}, on_dismiss_callback = null }) {
			this.title = title;
			this.paragraphs = Array.isArray(paragraphs) ? paragraphs : [paragraphs];
			this.interactive_html = interactive_html;
			this.buttons = Array.isArray(buttons) ? buttons : [buttons];
			this.options = options;
			this.on_dismiss_callback = on_dismiss_callback;

			this.open = true;
		},
		closeModal() {
			this.open = false;
			this.title = '';
			this.paragraphs = '';
			this.interactive_html = '';
			this.buttons = [];
			this.options = {};
			this.on_dismiss_callback = null;
		},
		addModalButtons(buttons = []) {
			if (Array.isArray(buttons) == false) {
				buttons = [buttons];
			}
			this.buttons = [...this.buttons, ...buttons];
		},
		updateButton(button_id, update_button_object) {
			let index = this.buttons.findIndex((button) => button.id == button_id);
			if (index > -1) {
				this.buttons[index] = {
					...this.buttons[index],
					...update_button_object,
				};
			}
		},
		updateProgressLabel(progress_label_object) {
			const is_progress_label_id_match = this.options?.progress_label?.id == progress_label_object.id;
			if (is_progress_label_id_match) {
				this.options.progress_label = {
					...this.options.progress_label,
					...progress_label_object,
				};
			}
		},
		openLicenseKeyModal({ is_extend_license_key = false } = {}) {
			this.is_license_key_modal_open = true;
			this.is_extend_license_key = is_extend_license_key;
		},
		closeLicenseKeyModal() {
			this.is_license_key_modal_open = false;
			this.is_extend_license_key = false;
		},
		openAudioStudio() {
			this.is_audio_studio_modal_open = true;
		},
		closeAudioStudio() {
			this.is_audio_studio_modal_open = false;
		},
		checkIfAnyModalIsOpen() {
			return this.open || this.is_audio_studio_modal_open || this.is_license_key_modal_open || this.is_extend_license_key || this.is_auto_address_modal_open;
		},

		handleModalInit: function () {
			//BETA Welcome Message
			// if (localStorage.getItem('has_shown_BETA_welcome_modal') != 'true') {
			// 	this.is_BETA_welcome_modal_open = true;
			// }
		},
	},
});
